<template>

    <div class="animated fadeIn" v-if="associatedProject.uuid">

        <b-row class="py-2">

            <b-card header="Editar Proyecto Asociado" class="w-100">

                <associated-project-form
                    class="px-3"
                    :associated-project="associatedProject"
                    :renderDeleteButton="mixinCheckPermission('QUERY_ANSWER_TYPE_DELETE')"
                    :renderSaveButton="mixinCheckPermission('ASSOCIATED_PROJECT_EDIT')"
                    @save-associated-project="updateAssociatedProject($event)"
                    @delete-associated-project="deleteAssociatedProject()">
                </associated-project-form>

            </b-card>

        </b-row>

    </div>

</template>

<script>

    import AssociatedProjectForm from './AssociatedProjectForm';
    import {updateAssociatedProject, deleteAssociatedProject, getAssociatedProject} from '@/api/associated-project-api';

    export default {
        name: "AddAssociatedProject",
        components: {AssociatedProjectForm},
        comments: {
            AssociatedProjectForm
        },
        data: function () {
            return {
                topmenu: [
                    {
                        name: 'Volver',
                        path: '/admin/associated-projects/list',
                        brand: 'fa fa-arrow-left'
                    },
                ],
                associatedProject: {}
            };
        },

        mounted() {
            this.$eventHub.$emit('captureMenu', this.topmenu);
            this.getAssociatedProject();
        },

        methods: {

            async getAssociatedProject() {
                this.$_loadingMixin_showLoading();
                await getAssociatedProject(this.$route.params.uuid)
                    .then((associatedProject) => {
                        this.associatedProject = associatedProject;
                    });
                this.$_loadingMixin_hideLoading();
            },

            updateAssociatedProject(associatedProject) {

                this.$_loadingMixin_showLoading();

                updateAssociatedProject(associatedProject)
                    .then(() => {
                        this.$_loadingMixin_hideLoading();
                        this.$_notificationMixin_success('Operación Completada', 'Proyecto asociado actualizado con éxito');
                        this.$router.push({path: '/admin/associated-projects/list'});
                    })
                    .catch(() => {
                        this.$_loadingMixin_hideLoading();
                        this.$_notificationMixin_error('Operación denegada', 'Algo salió mal');
                    });
            },

            deleteAssociatedProject() {

                swal({
                    title: '¿Estás seguro de eliminar este proyecto?', text: "Esta operación no se podrá revertir", type: 'warning',
                    showCancelButton: true, cancelButtonText: 'Cancelar', confirmButtonText: 'Sí, elimínalo!'
                }).then((result) => {
                    if (result.value) {

                        this.$_loadingMixin_showLoading();
                        deleteAssociatedProject(this.$route.params.uuid)
                            .then(() => {
                                this.$_notificationMixin_success('Operación Completada', 'Proyecto asociado eliminado con éxito');
                                this.$_loadingMixin_hideLoading();
                                this.$router.push({path: '/admin/associated-projects/list'});
                            })
                            .catch(() => {
                                this.$_notificationMixin_error('Operación denegada', 'Algo salió mal');
                                this.$_loadingMixin_hideLoading();
                            });

                    }
                });
            }

        }
    }
</script>